import React from 'react';

const Blog = () => {
    return (
        <div>
            <h2 className='text-success mt-4'>Difference between Authentication and Authorization</h2>
        <div className="row">
            <div className="col-md-6">
            Authentication
            <br />
            1.	In authentication process, the identity of users are checked for providing the access to the system.
            <br />
            2.	In authentication process, users or persons are verified.
            <br />
            3.	It is done before the authorization process.
            4.	It needs usually user’s login details. <br />
            </div>

            <div className="col-md-6">
            Authorization
            <br />
            1. While in authorization process, person’s or user’s authorities are checked for accessing the resources
            <br />
            2. While in this process, users or persons are validated.
            <br />
            3. While this process is done after the authentication process.
            <br />
            4. While it needs user’s privilege or security levels.
            </div>
        </div>

        <h4 className='mt-3 text-success'>Why are you using firebase? What other options do you have to implement authentication?</h4>
           <br />
           <p >Firebase manages all data real-time in the database. So, the exchange of data to and fro from the database is easy and quick. Hence, if you are looking to develop mobile apps such as live streaming, chat messaging, etc., you can use Firebase.</p>

           <br />
           5 Common Firebase Authentication Types <br />

    Password-based authentication. Passwords are the most common methods of authentication. ...
    Multi-factor authentication. ...
    Certificate-based authentication. ...
    Biometric authentication. ...
    Token-based authentication.
       
       <br />
       <br />
      <h4 className='text-success'>What other services does firebase provide other than authentication</h4> 
      <br />

     <li> Cloud Firestore. </li> 
     <li>Cloud Functions.</li>  
     <li>Authentication.</li> 
    <li>Hosting. </li>
    <li> Cloud Storage.</li>
     <li>  Google Analytics.</li>
      <li>  Predictions.</li>
      <li>Cloud Messaging.</li>
      <br />
    
        </div>
    );
};

export default Blog;